<template>
  <city-blank-form
    submit-label="Добавить город"
    :city="city"
    :errors="errors"
    form-type="add"
    @submit="processForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { addCity } from '@/services/city.service'
import cityBlankForm from '@/components/forms/city/CityBlankForm'

export default {
  name: 'city-add-form',
  components: { cityBlankForm },
  data () {
    return {
      city: {
        id: null,
        name: ''
      },

      errors: {
        city: {
          id: [],
          name: []
        }
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,

    processForm () {
      this.addCity().then((success) => {
        if (success) {
          this.showMsg('Город был успешно добавлен!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    addCity () {
      return addCity(this.city).then((response) => {
        this.city = response.data
        this.fillErrors(this.errors.city, {})
        return true
      }).catch(err => {
        this.fillErrors(this.errors.city, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// CityAddForm.vue?32830285